<template>
    <div class="">
        <div class="block block-bordered">
            <div class="block-header block-header-default">
                <div class="block-title">
                    Airtime Transactions
                </div>
            </div>
            <div class="block-content">
                <v-server-table theme="bootstrap4" :columns="columns" :options="options">
                    <span slot="transaction_sttus"></span>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AirtimeTransactions",
        data() {
            return {
                transactions: {},
                columns: [
                    'phone_number',
                    'amount',
                    'transaction_id',
                    'transaction_status',
                    'network',
                    'created_at'
                ],
                options: {
                    requestFunction: function (data) {
                        return axios.get(`web/projects/${this.$route.params.project}/airtime/transactions`, {
                            params: data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }
                }
            }
        },
        mounted() {
            this.fetchTransactions()
        },
        methods: {
            /**
             *
             */
            fetchTransactions() {

            }
        }
    }
</script>

<style scoped>
    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: auto;
        text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "+";
    }

    .VueTables__child-row-toggler--open::before {
        content: "-";
    }
</style>
